export * from "./src/paid-tabs";
export { PaidTabs as default } from "./src/paid-tabs";
